import * as yup from 'yup'
import { MessagesYup } from '../../messages'
import {
  CenarioMetadataResponse,
  ChaveValorMetadata,
  TipoCenario
} from '../types'
import { paraDiaCivil } from '../utils/vigencia'

// `mixed().required` do yup 0.32 aceita '' (valor inicial do campo), então o "em branco" é conferido à mão.
const estaEmBranco = (valor: unknown) =>
  valor === undefined || valor === null || String(valor).trim() === ''

const schemaDoValor = (chave: ChaveValorMetadata) => {
  let schema = yup.mixed()

  if (chave.obrigatorio) {
    schema = schema.test(
      'preenchido',
      MessagesYup.MENSAGEM_OBRIGATORIO,
      valor => !estaEmBranco(valor)
    )
  }

  if (chave.dominio.tipo === 'numero') {
    const { min, max } = chave.dominio

    // Vale para chave opcional também, quando preenchida.
    schema = schema
      .test(
        'minimo',
        `Valor deve ser no mínimo ${min}`,
        valor =>
          min === undefined || estaEmBranco(valor) || Number(valor) >= min
      )
      .test(
        'maximo',
        `Valor deve ser no máximo ${max}`,
        valor =>
          max === undefined || estaEmBranco(valor) || Number(valor) <= max
      )
  }

  return schema
}

export const buildCenarioSchema = (metadata: CenarioMetadataResponse | null) =>
  yup.object().shape({
    tipo: yup.string().required(MessagesYup.MENSAGEM_OBRIGATORIO),
    descricao: yup.string().trim().required(MessagesYup.MENSAGEM_OBRIGATORIO),
    dataInicio: yup
      .date()
      .nullable()
      .required(MessagesYup.MENSAGEM_OBRIGATORIO),
    dataFim: yup
      .date()
      .nullable()
      .test(
        'vigencia',
        'Data de fim deve ser maior ou igual à de início',
        function (dataFim) {
          if (!dataFim) {
            return true
          }
          // Compara dias: o seletor mantém a hora corrente, e fim no mesmo dia do início é válido.
          return paraDiaCivil(dataFim) >= paraDiaCivil(this.parent.dataInicio)
        }
      ),
    valores: yup.lazy((_valores, options) => {
      const tipo = options?.parent?.tipo as TipoCenario | undefined
      const chaves = (tipo && metadata?.tipos[tipo]?.chaves) || []

      return yup.object().shape(
        Object.fromEntries(
          chaves
            // Booleano sempre tem valor (S ou N): não há o que exigir.
            .filter(chave => chave.dominio.tipo !== 'booleano-sn')
            .map(chave => [chave.chave, schemaDoValor(chave)])
        )
      )
    })
  })
